import React from 'react';

const Filter: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = props => (
  <svg viewBox="0 0 25 25" strokeWidth={1.25} strokeLinecap="round" {...props}>
    <g fill="none">
      <path d="M18.862 7.59h3.705M2.5 7.59h11.786" />
      <circle cx={16.518} cy={7.589} r={2.232} />
      <path d="M6.205 16.964H2.5M22.567 16.964H10.781" />
      <circle cx={8.549} cy={16.964} r={2.232} />
    </g>
  </svg>
);

export default Filter;
